// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";
import store from "./store";
import axios from "axios";
import io from "socket.io-client";
import moment from "moment";
import setAuthToken, { initializeAuthToken } from "./utils/authToken";


let socket = null;

let socketUrl = process.env.VUE_APP_SOCKET_URL;

if (process.env.NODE_ENV === "development") {
  console.log("Dev Mode");
}

// socket = io(window.location.host);
socket = io(socketUrl);

socket.on("connect", function () {
  console.log("[%s]on connect...", socket.id);
});

store.dispatch("assignSocket", socket);

/** Check for auth token on refresh and set authorization header for incoming requests */
const token = initializeAuthToken();
if (token) {
  console.log('Token restored from storage');
} else {
  setAuthToken(null);
}

/** Axios Request Intercept */
axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

/** Axios Response Intercept */
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (err) {
    // Only logout on 401 Unauthorized errors, not on all errors
    if (err.response && err.response.status === 401) {
      console.warn('Authentication failed - logging out user');
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      store.dispatch("toggleAuthState", false);
      
      // Only redirect to login if we're not already on a public page
      const currentRoute = router.currentRoute.value;
      if (currentRoute.meta.requiresAuth !== false) {
        router.push({
          name: "Login",
          params: { message: "Session has expired, please login again" },
        });
      }
    }
    return Promise.reject(err);
  }
);

const app = createApp(App);
app.config.globalProperties.moment = moment;
  
app.use(i18n);
app.use(router);
app.use(store);
app.mount("#app");
